module.exports = __webpack_public_path__ + "img/face43.e053159c.gif";